import { ContractorObjectGroups, ContractorObjectItem, ContractorObjectType } from '../bus/contractorObject/types';
import $axios from '../utils/axios-instance';

export default class ContractorObjectsApi {
  async getContractorObjectList() {
    return await $axios
      .get<{ data: ContractorObjectItem[] }>('/v1/ContractorObject')
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getContractorObjectDetail(data: { id: number | string }) {
    return await $axios
      .get<ContractorObjectItem>(`/v1/ContractorObject/${data.id}/details`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async createContractorObject(data: Omit<ContractorObjectItem, 'id'>) {
    return await $axios
      .post('/v1/ContractorObject', data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async changeContractorObject(data: ContractorObjectItem) {
    return await $axios
      .put(`/v1/ContractorObject/${data.id}`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async deleteContractorObject(data: { id: number | string }) {
    return await $axios
      .delete(`/v1/ContractorObject/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getContractorObjectTypes() {
    return await $axios
      .get<ContractorObjectType[]>('/v1/ContractorObject/types')
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
  async getContractorObjectGroups(data: { contractorId: number | string }) {
    return await $axios
      .get<ContractorObjectGroups[]>(`/v1/ContractorObject/${data.contractorId}/groups`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
}
